import React, { useEffect } from "react";
import LoadingSpinner from "components/library/loading-spinner/LoadingSpinner";
import { RouteConstants } from "components/route/RouteConstants";
import auth from "./services/Auth";
import logger from "utils/logger";
import { checkRoleHasAccess } from "./RolesConfig";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setUserProfile } from "store/reducers/user";

const AuthCallback = () => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const dispatch = useDispatch()
    useEffect(() => {
        const handleAuthentication = async () => {
            try {
                const authResult = await auth.handleAuthentication();
                const userProfile = (authResult || {}).idTokenPayload;

                if (userProfile) {
                    // set profile, regardless of what kind of auth this is
                    dispatch(setUserProfile(userProfile));

                    // now, check for regular auth. we don't want any of this to
                    // run if this callback is getting hit from silent auth
                    if (auth.isRegularAuthentication(authResult)) {
                        /* istanbul ignore next */
                        if (!userProfile.userRole || !checkRoleHasAccess(userProfile.userRole, "TPSC")) {
                            navigate(RouteConstants.UNAUTHORIZED);
                        } else {
                            i18n.changeLanguage(authResult.lang);
                            navigate(sessionStorage.getItem("visitedPageName") || "/");
                            sessionStorage.removeItem("visitedPageName");
                        }
                    }
                }

                // auth is now handled successfully. rejoice!
            } catch (err: any) {
                logger.noticeError(`AuthCallback: Exception occured in AuthCalback (${err}) ${err && err.error}`);
                if(err.error === "invalid_transaction_data") {
                    navigate("/"); // invalid transaction error - state key missing in response, Login again to generate new values
                    return;
                }
                navigate(RouteConstants.AUTH_ERROR);
            }
        };

        handleAuthentication();
    }, []);

    return <LoadingSpinner />;
};


export default AuthCallback;
